<!--주문취소 버튼-->
<template>
    <!-- <button type="button" class="btn-m" @click="doOrderCancel">{{title}}</button> -->
    <button type="button" class="btn-m" @click="showConfirmCancle">{{title}}</button>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props:{
        title : {
            type: String,
            required: true
        },
        opId : {
            type: String,
            required: true
        },
        status : {
            type: String,
            required: true
        },
    },

    data() {
        return {
            processiong: false // 버튼 더블클릭 방지
        }
    },

    computed: {
		...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
        }),	
	},

    methods : {
        showConfirmCancle(){
            this.$store.commit('modalStore/setVisibleCancelOrderConfirmPopup', true);
        },
    },

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/order.scss';
</style>